document.querySelectorAll(".select__select").forEach((select) => {
    const fixedCartPrice = document.getElementById("fixedCartPrice");
    select.addEventListener("change", () => {
        const result = meta.product.variants.filter(
            (variant) => variant.public_title === select.value
        );
        fixedCartPrice.textContent = (
            Number(result[0].price) / 100
        ).toLocaleString();
    });
});
